import MyDataTable from "../../../../component/MyDataTable";

const DefectivePartToBeSendToPartner = ({ setReload, reloadList }) => {
  const getInvoiceChallan = (is_invoice) => {
    return Number(is_invoice) === 1 ? 'Invoice' : 'Challan'
  }


  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: <div className="word-wrap">Partner name</div>,
      selector: (row) => row.partner_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Partner Gst Number</div>,
      selector: (row) => row.to_gst_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Invoice/Challan</div>,
      selector: (row) => getInvoiceChallan(row.is_invoice),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Appliance</div>,
      selector: (row) => `${row.appliance_name}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Part Name / Number</div>,
      selector: (row) =>
        `${row.part_name} / ${row.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Total Qty In Warehouse</div>,
      selector: (row) => `${row.total_shipped_quantity}`,
      wrap: true,
    },
  ];

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">

              <MyDataTable
                reloadList={reloadList}
                columns={columns}
                getDataListURL={`getreversepartreceivedbywarehouse?`}
                setReload={setReload}
                exportName={"partlist"}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DefectivePartToBeSendToPartner;
